import React from "react";
import { Helmet } from "react-helmet";
import StaticPageStyle from "./StaticPageStyle";

const LIST_WITH_US_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSdYLA04s7-ukv41l_mw9MbaQxmX2LFtHGn2Nw54eVc_NEBOIw/viewform";

const ListWithUs = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>List Your Property With Us — Propeller PH</title>
        <meta
          name="description"
          content="Sell or lease your property with Propeller PH. Tell us about your property and our team will handle the listing, marketing, and inquiries."
        />
        <link rel="canonical" href="https://www.propeller.ph/list-with-us" />
      </Helmet>
      <StaticPageStyle>
        <div className="container">
          <h1>List Your Property With Us</h1>
          <p className="page-meta">
            For owners selling or leasing residential and commercial
            properties.
          </p>

          <p>
            Propeller PH markets residential and commercial properties for
            sale and lease across Metro Manila and beyond. When you list with
            us, your property gets a dedicated listing page on propeller.ph
            with photos, full details, and location information — plus
            promotion to our audience on Facebook, Instagram, and YouTube. Our
            team handles inquiries and coordinates viewings with interested
            buyers and tenants.
          </p>

          <h2>How it works</h2>
          <ul className="steps">
            <li>
              <strong>Tell us about your property.</strong> Fill out our
              listing form with the property's location, type, size, and your
              asking price.
            </li>
            <li>
              <strong>We review and get in touch.</strong> Our team will
              contact you to confirm details, discuss pricing, and arrange
              photos.
            </li>
            <li>
              <strong>Your listing goes live.</strong> We publish your
              property on propeller.ph, promote it, and bring qualified
              inquiries to you.
            </li>
          </ul>

          <a
            className="btn-primary"
            href={LIST_WITH_US_FORM_URL}
            target="_blank"
            rel="noreferrer"
          >
            Start your listing
          </a>

          <h2>Prefer to talk first?</h2>
          <p>
            Email us at{" "}
            <a href="mailto:propeller.realty@gmail.com">
              propeller.realty@gmail.com
            </a>{" "}
            or call <a href="tel:+639060012922">+63 906 001 2922</a> and we'll
            walk you through the process.
          </p>
        </div>
      </StaticPageStyle>
    </React.Fragment>
  );
};

export default ListWithUs;
